import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { DialogModalWithForm } from "../Components/DialogModal";
import { StyledPrimaryButton } from "../Components/StyledComponents/Buttons";
import { useStores } from "..";
import { PasswordInput } from "../Components/PasswordInput";
import dictionary from "../langs.json";
import { ServerRequestError } from "../ServerClients/Configs";

export const LoginForm: React.FC<{}> = observer(() => {
  let appStores = useStores();
  let mainWindowStore = appStores.mainWindowStore;
  let loginStore = appStores.loginStore;
  const [error, setError] = useState<"password" | "generic" | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const language = navigator.language.toLowerCase().split("-")[0] === "en" ? "en" : "ru";
  const messages = dictionary[language].translation;
  useEffect(() => { setError(null); }, [mainWindowStore.showUserLogin]);

  if (!mainWindowStore.showUserLogin) {
    return null;
  }

  let closeUserLoginAndShowRegistration = function () {
    mainWindowStore.onRegistrationOpen();
    mainWindowStore.onUserLoginClose();
  };
  return (
    <DialogModalWithForm
      className="auth-form"
      onCloseClick={mainWindowStore.onUserLoginClose}
      onSubmit={() => {
        if (submitting) return;
        setError(null);
        setSubmitting(true);
        loginStore.loginUser().then((authenticated) => {
          if (authenticated) mainWindowStore.onUserLoginClose();
          else setError("generic");
        }).catch((failure: unknown) => {
          setError(failure instanceof ServerRequestError && failure.status === 401
            && failure.message.startsWith("AuthorizationException:") ? "password" : "generic");
        }).finally(() => setSubmitting(false));
      }}
    >
      <DialogModalWithForm.Header>Авторизация</DialogModalWithForm.Header>
      <DialogModalWithForm.Body>
        {error && <div className="login-error" role="alert">
          <p>{error === "password" ? messages.login_incorrect_password : messages.login_failed}</p>
          {error === "password" && <>
            <p>{messages.login_reset_advice}</p>
            <a href="#password-reset" onClick={(event) => {
              event.preventDefault();
              mainWindowStore.onPasswordResetOpen();
            }}>{messages.registration_reset_link}</a>
          </>}
        </div>}
        <div>
          <label htmlFor="login-email">Электронная почта</label>
          <input
            id="login-email"
            type="email"
            placeholder="Эл. почта"
            className="login"
            required
            onChange={(event) => { setError(null); loginStore.onChangeUserMail(event); }}
          />
        </div>
        <div>
          <label htmlFor="login-password">Пароль</label>
          <PasswordInput
            id="login-password"
            type="password"
            placeholder="Пароль"
            className="pass"
            minLength={8}
            required
            onChange={(event) => { setError(null); loginStore.onChangeUserPassword(event); }}
          />
        </div>
        <div>
          <StyledPrimaryButton type="submit" disabled={submitting} aria-busy={submitting}>Войти</StyledPrimaryButton>
        </div>
      </DialogModalWithForm.Body>
      <DialogModalWithForm.Footer>
        <a onClick={closeUserLoginAndShowRegistration}>Регистрация</a>
        <a href="#password-reset" onClick={(event) => {
          event.preventDefault();
          mainWindowStore.onPasswordResetOpen();
        }}>Забыли пароль?</a>
      </DialogModalWithForm.Footer>
    </DialogModalWithForm>
  );
});
